
import React from "react";
import BookingForm from "../components/BookingForm";

const BaltimoreMansions = () => {
  return (
    <div className="bg-[#F2F1F0] text-[#144E73] font-sans min-h-screen pt-16 pb-20 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-primarymb-10 text-center">
          Vanderbijlpark – Baltimore Mansions – Self-Catering
        </h1>

        {/* Gallery + Description */}
        <div className="grid md:grid-cols-2 gap-10 mb-16 items-start">
  {/* Gallery */}
  <div className="grid grid-rows-[auto_1fr] gap-4">
    <img
      src="/images/baltimore/main.jpg"
      alt="Baltimore Mansions Main"
      className="rounded-lg aspect-[16/9] object-cover border-4 border-[#FEB339]"
    />
    <div className="grid grid-cols-2 gap-4">
      {[...Array(6)].map((_, i) => (
        <img
          key={i}
          src={`/images/baltimore/${i + 1}.jpg`}
          alt={`Baltimore Gallery ${i + 1}`}
          className="rounded-lg aspect-[4/3] object-cover border-4 border-[#FEB339]"
        />
      ))}
    </div>
  </div>

          {/* Description */}
          <div>
            <p className="text-lg leading-relaxed mb-4">
              Baltimore Mansions offers modern, self-catering suites perfect for both short and extended stays. Located in the heart of Vanderbijlpark near Vaal Mall, it's a favorite for business travelers and families alike.
            </p>
            <ul className="list-disc ml-5 text-sm space-y-2">
              <li>Close to Vaal Mall</li>
              <li>Breakfast available at El Paso Spur</li>
              <li>Spacious rooms with lounge suite</li>
              <li>Secure parking</li>
              <li>Fax, email, and copy facilities available</li>
            </ul>

         
          </div>
        </div>

     
        {/* Booking Form */}
        <BookingForm  hotelName="Baltimore Mansions"/>
      </div>
    </div>
  );
};

export default BaltimoreMansions;
